export default "<button title=\"{{'BUTTONS.open' | translate}}\" class=\"{{class}}\" (click)=\"open()\">{{'BUTTONS.open' | translate}}</button>\r\n";